import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import './ThankYouLetter.scss'

const ThankYouLetter = ({ data, paymentData }) => {
    const navigate = useNavigate()

    const [time, setTime] = useState(3)
    const isPayment = data?.is_payment && paymentData.amount.rub > 0
    let interval = null

    // console.log(paymentData)
    // console.log(data?.is_payment)

    useEffect(() => {
        if (isPayment) {
            navigate(`/payment/?invoice_id=${paymentData?.invoice_id}`)
        }

        return () => clearInterval(interval)
    }, [])

    console.log(paymentData)

    return (
        <div className="thankyou-letter lg:pl-4">
            <h2 className="title">Спасибо!</h2>
            <div className="letter">
                {data?.success_message && <p className="letter mb-2">{data?.success_message}</p>}
                {isPayment && (
                    <p>
                        Вы будете перенаправлены на страницу оплаты
                    </p>
                )}
            </div>
        </div>
    )
}

export default ThankYouLetter
